import {IProgramModule} from "@/_types/program-module";

import { IBase, IImage, SECTION_THEME_ENUM } from './base'
import { IBenefit } from './benefit'

export enum I_AP_CATEGORY_ID_ENUM {
	FEMALE = 2,
	MALE = 1,
	FAMILY = 3,
	CHILD = 4
}

export interface IAPCards {
	id: number
	name: string
	slug: string
	image: IImage
}

export interface IAPCategoryReduced extends IBase {
	id: number
	name: string
	nameShort?: string
	slug: string
	title: string
	description: string
	sectionTheme: SECTION_THEME_ENUM
	yearPrograms: IAnnualProgram[]
	image: IImage
	sectionImage?: IImage
}

export interface IAPCategory extends IAPCategoryReduced {}

export interface IAnnualProgramReduced {
	id: number
	name: string
	cardHeaderDescription: string | null
	price: number
	priceOld: number
	isSolo: boolean
	categoryId: number
	parentId: number | null
	url?: string
}

export interface IAnnualProgram extends IAnnualProgramReduced {
	description: string | null
	priceInsurance: number
	isFeatured: boolean
	isExpanded: boolean | undefined
	benefits: IBenefit[]
	modules: IProgramModule[] | null
	_childProgram?: IAnnualProgram
}

export interface IAnnualProgramList {
	familyItems: IAnnualProgram[]
}

export enum IAnnualProgramDiscountType {
	// Program Medante Platinum/ Medante Vital – bez platenia – v rámci programu
	// Program Medante Balance (terajšie SOLO) – s 10% zľavou za termín.
	// Program Medante SOLO/ MINI – s plnou sumou
	// Program Medante Premium a Comfort – s hláškou: Žiaľ pre Váš program funkcia objednania na termín online v rámci Vášho programu nie je možná. Pre objednanie kontaktujte naše klientske centrum.

	/**
	 * Platinum / Vital
	 */
	NO_PAYMENT = 'NO_PAYMENT',

	/**
	 * Balance
	 */
	DISCOUNT_10 = 'DISCOUNT_10',

	/**
	 * Solo / Mini
	 */
	NO_DISCOUNT = 'NO_DISCOUNT',

	/**
	 * Premium / Comfort
	 */
	UNABLE_TO_CALCULATE = 'UNABLE_TO_CALCULATE'
}
